"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemType = void 0;
var MenuItemType;
(function (MenuItemType) {
    MenuItemType["Dashboard"] = "dashboard";
    MenuItemType["Link"] = "link";
    MenuItemType["Action"] = "action";
})(MenuItemType || (exports.MenuItemType = MenuItemType = {}));
//# sourceMappingURL=IMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/model/IMenuItem.js
// module id = 1751
// module chunks = 0